module.exports = __webpack_public_path__ + "static/fonts/iconfont.923bbdf8.woff";